import React from "react";
/* EmptyState — Phase B primitive.
   size: inline (single line) | compact (~120h) | large (full section, default) */

export default function EmptyState({ icon, title, message, action, size = "large", className = "", ...rest }) {
  return (
    <div
      className={`v2-empty v2-empty--${size} ${className}`.trim()}
      role="status"
      {...rest}
    >
      {icon != null ? <div className="v2-empty__icon" aria-hidden="true">{icon}</div> : null}
      {title != null ? <div className="v2-empty__title">{title}</div> : null}
      {message != null ? <div className="v2-empty__message">{message}</div> : null}
      {action != null ? <div className="v2-empty__action">{action}</div> : null}
    </div>
  );
}
